import React, { useContext } from 'react'
import { Box, Text } from '@usap/uicomponents'

import { LocalContext } from '../../../helpers/useLocalContext'
import { SearchContext } from '../../common/context/SearchContextProvider'

const itemPerPage = 'itemperpage'
const defaultPageItems = 15

const currentPage = 'currentpage'
const defaultCurrentPage = '1'

export default function TopBarInformation() {
  const {
    searchState: { products },
  } = useContext(SearchContext)

  const { localContext } = useContext(LocalContext)
  const { history } = localContext

  const urlParams = new URLSearchParams(
    __BROWSER__ ? window.location.search : history.location.pathname,
  )

  const pageItemsCount = Number(urlParams.get(itemPerPage) || defaultPageItems)
  const pageNumber = Number(urlParams.get(currentPage) || defaultCurrentPage)

  const { resultCount: numberOfProducts = 0 } = products

  const hasMinNumberOfProducts = pageItemsCount > numberOfProducts
  const shownRecords = hasMinNumberOfProducts
    ? numberOfProducts
    : pageItemsCount

  return (
    <Box id="topBarinformation">
      <Text size="small" color="dark-2">
        Showing
        {' '}
        <Text weight="bold" size="small" color="dark-2">
          {shownRecords * pageNumber - shownRecords + 1}
          {' '}
          -
          {' '}
          {shownRecords * pageNumber < numberOfProducts
            ? shownRecords * pageNumber
            : numberOfProducts}
        </Text>
        {' '}
        of
        {' '}
        <Text weight="bold" size="small" color="dark-2">
          {numberOfProducts}
          {' '}
        </Text>
        results
      </Text>
    </Box>
  )
}
